/**
 * Lightweight haptic feedback helper.
 * Uses the Web Vibration API where supported (Android Chrome/Firefox).
 * Silently no-ops on iOS Safari and desktop browsers.
 */

const isEnabled = () => {
  try {
    return typeof window !== 'undefined'
      && typeof navigator !== 'undefined'
      && typeof navigator.vibrate === 'function'
      && localStorage.getItem('gt_haptics_off') !== '1';
  } catch { return false; }
};

/** Quick tick for taps on tabs, chips, secondary buttons. */
export function tap() {
  if (!isEnabled()) return;
  try { navigator.vibrate(8); } catch { /* ignore */ }
}

/** Two-tick "confirm" for primary CTAs and successful submits. */
export function confirm() {
  if (!isEnabled()) return;
  try { navigator.vibrate([10, 30, 10]); } catch { /* ignore */ }
}

/** Longer buzz for errors / destructive actions. */
export function error() {
  if (!isEnabled()) return;
  try { navigator.vibrate([40, 60, 40]); } catch { /* ignore */ }
}

/** Disable haptics (e.g. from a user preference). */
export function setEnabled(on) {
  try {
    if (on) localStorage.removeItem('gt_haptics_off');
    else localStorage.setItem('gt_haptics_off', '1');
  } catch { /* ignore */ }
}
